import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import createDateForBackEnd from '@/employee/omApplications/common/omApplicationTools';

export default {
  name: 'Manpowers',
  components: {
    ManpowerComp: require('./manpower.vue').default,
  },
  mixins: [createDateForBackEnd],
  props: ['dataObj'],
  data: function () {
    return {
      jobcardData: {
        id: -1,
        originType: '-1',
        originId: -1,
        stationId: -1,
        startDateTime: new Date(),
        dateFromHH: '00',
        dateFromMin: '00',
        endDateTime: new Date(),
        actualDuration: 0,
        actualTravelDuration: 0,
        address: '',
        mActivityId: -1,
        elementTypeId: -1,
        elementId: -1,
        conditionId: -1,
        conditionComment: '',
        complainTypeId: -1,
        outcomeId: -1,
        comment: '',
        workflowEmployeeId: -1,
        dataChildren: undefined
      },
      bShowRates: false,
      sourceId: -1,
      stationId: 0,
      employeeUsage: 1,
      workDuration: 0,
      travelDuration: 0,
      empUsages: [],
      rateTypes: [],
      sourceTypes: [],
      manpowers: [],
      stations: [],
      availableEmployees: [],
      editingManpower: {},
      bHoursForDuration: false,
      options: { pageSize: 5, total: 0, page: 1 },
      message: '',
      showManpower: false,
      totalRow: 0,
      bInitialized: false,
      bPageChange: true,
    }
  },
  mounted() {

  },
  created() {
    this.getSettingsOm();
    this.getStations();
    this.getManpowerLookups();
    this.getAvailableEmployees();
    this.getOmUseHoursForDuration();
    this.init();
    //this.$root.$on('investigation_or_jobcard_updated', this.init);
  },
  computed: {
    startDateTime: function () {
      return this.jobcardData.startDateTime ? this.jobcardData.startDateTime : this.jobcardData.dateTimeFrom;
    },
    endDateTime: function () {
      return this.jobcardData.endDateTime ? this.jobcardData.endDateTime : this.jobcardData.dateTimeTo;
    },
    dateFromHH: function () {
      return this.jobcardData.dateFromHH;
    },
    dateFromMin: function () {
      return this.jobcardData.dateFromMin;
    },
    actualDuration: function () {
      return this.jobcardData.actualDuration;
    },
    actualTravelDuration: function () {
      return this.jobcardData.actualTravelDuration;
    },
  },
  methods: {
    getSettingsOm() {
      axios.post('/Om/GetSettings')
        .then(response => {
          if (response.data.data.status == 0) {
            this.bShowRates = response.data.value.isShowManpowerAndSupportServicesRates;
          }
        });
    },
    pageChange(pInfo) {
      //var parameters = { Value: this.appId, PageSize: pInfo.pageSize, Page: pInfo.pageNumber, FilterText: this.search };
      if (this.bPageChange === true)
        this.bPageChange = false
      else
        this.getManpowers();
    },
    getEmployeeText(iKey) {
      return (this.availableEmployees.filter(t => t.employeeId == iKey).length > 0) ? this.availableEmployees.filter(t => t.employeeId == iKey)[0].name : '';
    },
    getRateText(iKey) {
      return (this.rateTypes.filter(t => t.id == iKey).length > 0) ? this.rateTypes.filter(t => t.id == iKey)[0].name : '';
    },
    init() {
      Vue.nextTick(() => {
        this.bInitialized = false;
        this.jobcardData = this.dataObj;
        this.sourceId = this.dataObj.dataChildren ? this.dataObj.dataChildren.sourceId : this.sourceId;
        this.stationId = this.dataObj.dataChildren ? this.dataObj.dataChildren.stationId : this.stationId;
        this.employeeUsage = this.dataObj.dataChildren ? this.dataObj.dataChildren.empUsage : this.employeeUsage;
        this.workDuration = this.dataObj.dataChildren ? this.dataObj.actualDuration : this.workDuration;
        this.travelDuration = this.dataObj.dataChildren ? this.dataObj.actualTravelDuration : this.travelDuration;
        if (this.sourceId > -1)
          this.getManpowers();
      });
    },
    getOmUseHoursForDuration() {
      axios.post('/Utility/GetOmUseHoursForDuration')
        .then(response => {
          if (response.data.data.status == 0) {
            this.bHoursForDuration = response.data.value;
          }
          else {
            this.$alertMsg(response.data.data.text)
          }
        })
        .catch(e => {
          console.log('getOmUseHoursForDuration');
          console.log(e);
          this.$router.push('/login');
          return false;
        })
    },
    getStations() {
      axios.post('/Om/GetStations')
        .then(response => {
          if (response.data.data.status == 0) {
            this.stations = response.data.items;
          }
          else {
            this.$alertMsg(response.data.data.text)
          }
        })
        .catch(e => {
          console.log('getStations');
          console.log(e);
          this.$router.push('/login');
          return false;
        })
    },
    getManpowerLookups() {
      axios.post('/Om/GetManpowerLookups')
        .then(response => {
          if (response.data.data.status == 0) {
            this.empUsages = response.data.empUsages;
            this.rateTypes = response.data.rateTypes;
            this.sourceTypes = response.data.sourceTypes;
          }
          else {
            this.$alertMsg(response.data.data.text)
          }
        })
        .catch(e => {
          console.log('getManpowerLookups');
          console.log(e);
          this.$router.push('/login');
          return false;
        })
    },
    getAvailableEmployees() {
      var parameters = { StationId: -1, TeamId: -1, Filter: '' };
      axios.post('/Om/GetAvailableManpower', parameters)
        .then(response => {
          if (response.data.data.status == 0) {
            response.data.items.forEach((item) => { item.fullname = item.name + " - " + item.orgpost; });
            this.availableEmployees = response.data.items;
          }
          else {
            this.$alertMsg(response.data.data.text)
          }
        })
        .catch(e => {
          console.log('getAvailableEmployees');
          console.log(e);
          this.$router.push('/login');
          return false;
        })
    },
    getManpowers() {
      this.bInitialized = false;
      var parameters = { SourceType: this.employeeUsage, SourceId: this.sourceId };
      this.$store.state.notifier.asyncBlock(
        axios.post('/Om/GetManpowerAllocations', parameters),
        response => {
          if (response.status === 200 && response.data.data.status === 0) {
            response.data.items.forEach(i => {
              i.travelDuration = Math.round(i.travelDuration / 60);
              i.workDuration = Math.round(i.workDuration / 60);
            });
            this.manpowers = response.data.items;
            this.options.total = response.data.total;
            this.totalRow = response.data.total;
            this.bInitialized = this.jobcardData.id > 0;
          }
          else {
            this.$alertMsg(response.data.data.text)
          }
        },
        err => {
          this.$alertMsg(err.response.data);
          this.$router.push('/login');
        },
        'Loading Manpower Allocations'
      );
    },
    add() {
      this.editingManpower = {
        allocationId: -1,
        employeeId: -1,
        employee: { fullname: '' },
        sourceType: this.employeeUsage,
        sourceId: this.sourceId,
        scheduledDateTime: this.startDateTime,
        scheduledTimeHH: this.jobcardData.dateFromHH, //this.dateFromHH,
        scheduledTimeMin: this.jobcardData.dateFromMin, //this.dateFromMin,
        startDateTime: this.startDateTime,
        endDateTime: this.endDateTime,
        workDuration: this.actualDuration,
        travelDuration: this.actualTravelDuration,
        rateType: 1,
        readonly: false,
        duration: (this.bHoursForDuration == true ? 'Hours' : 'Minutes'),
        rateHr: 0,
        bShowRateField: this.bShowRates,
        rateTypes: this.rateTypes,
        availableEmployees: this.availableEmployees,
        stations: this.stations,
        stationId: this.stationId
      };
      this.$root.$emit('manpower_updated');
      this.showManpower = true;
    },
    edit(manpower) {
      this.editingManpower = manpower;

      this.editingManpower.stations = this.stations;
      this.editingManpower.stationId = this.stationId;
      this.editingManpower.rateTypes = this.rateTypes;
      this.editingManpower.availableEmployees = this.availableEmployees;
      this.editingManpower.duration = (this.bHoursForDuration == true ? 'Hours' : 'Minutes');
      this.editingManpower.readonly = false;
      this.editingManpower.employee = this.editingManpower.availableEmployees.filter(item => item.employeeId === this.editingManpower.employeeId)[0],

      this.editingManpower.scheduledTimeHH = moment(this.editingManpower.scheduledDateTime).format('HH');
      this.editingManpower.scheduledTimeMin = moment(this.editingManpower.scheduledDateTime).format('mm');
      this.editingManpower.endDateTime = this.endDateTime;

      this.editingManpower.bShowRateField = this.bShowRates;

      this.$root.$emit('manpower_updated');
      this.showManpower = true;
    },
    saveManpower() {
      if (!this.editingManpower.scheduledDateTime || !this.editingManpower.scheduledTimeHH || !this.editingManpower.scheduledTimeMin) {
        this.$alertMsg(this.$t('jobcard.DateComplete'), 4);
        return;
      }

      var sUrl = (this.editingManpower.allocationId == -1) ? '/Om/AddManpowerAllocation' : '/Om/UpdateManpowerAllocation';
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });

      let param = {
        SourceType: this.editingManpower.sourceType,
        AllocationId: this.editingManpower.allocationId,
        EmployeeId: this.editingManpower.employee.employeeId,
        ScheduledDateTime: this.createDateForBackEnd(this.editingManpower.scheduledDateTime),
        ScheduledDateHours: this.editingManpower.scheduledTimeHH,
        ScheduledDateMinutes: this.editingManpower.scheduledTimeMin,
        RateType: this.editingManpower.rateType,
        RateHr: this.editingManpower.rateHr,
      }


      if (this.editingManpower.sourceId)
        param['SourceId'] = this.editingManpower.sourceId;

      if (this.editingManpower.workDuration)
        param['WorkDuration'] = this.editingManpower.workDuration;

      if (this.editingManpower.travelDuration)
        param['TravelDuration'] = this.editingManpower.travelDuration;

      axios.post(sUrl, param)
        .then(response => {
          if (response.data.data.status == 0) {
            this.getManpowers();
            this.$alertMsg(this.$t('messages.ManpowerSavedSuccess'), 2);
          }
          else
            this.$alertMsg(response.data.data.text)

          loader.hide();
          this.showManpower = false;
        })
        .catch((e) => {
          console.log('saveManpower');
          console.log(e);
          loader.hide();
          this.$alertMsg(e.message)
        })
    },
    remove(id) {
      axios.post('/Om/RemoveManpowerAllocations', { SourceType: this.employeeUsage, SourceId: this.sourceId, AllocationId: id })
        .then(response => {
          if (response.data.data.status == 0) {
            this.$alertMsg(this.$t('messages.ManpowerDeletedSuccess'), 2);
            this.getManpowers();
          }
        })
        .catch((e) => {
          console.log('remove');
          console.log(e);
          this.$alertMsg(e.message)
        })
    },
    getTimeLabel(fullDate) {
      var res = new Date(fullDate);
      return (res.getHours() < 10 ? '0' + res.getHours() : res.getHours()) + ':' + (res.getMinutes() < 10 ? '0' + res.getMinutes() : res.getMinutes());
    },
    closeDialog() {
      this.editingMessage = '';
      this.getManpowers();
      this.showManpower = false;
    },
    onPagination(args) {
      this.options.page = args.page;
      this.options.pageSize = args.size;
      this.getManpowers();
    },
  },
  
}
